module.exports = __webpack_public_path__ + "static/media/ic-history-hover.7decb9f6.svg";